// extracted by mini-css-extract-plugin
export var actionText = "_j8-4";
export var container = "_j8-0";
export var leftSection = "_j8-1";
export var rightSection = "_j8-2";
export var settingsButton = "_j8-6";
export var settingsIcon = "_j8-7";
export var shortcut = "_j8-5";
export var shortcutGroup = "_j8-3";